import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import DoctorSchedule from "./DoctorsSchedule";

function VisitingDoctors() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <h1>Specialist Consultations</h1>
            <p className="caboutus">
                Specialist Consultations visits are scheduled on a weekly basis. The detailed schedule is listed below for your reference:
            </p>

            <DoctorSchedule />
           

            <h5 className="text-teal m-4 mb-4">Kindly note that, there will be no prior appointments required.</h5>

            <h5 className="text-teal m-4 mb-4">If there are any schedule changes in the specialist visit, the Health Centre will notify you as soon as possible.</h5> 
            
            
        </div>
    );
}

export default VisitingDoctors;
